export default __webpack_public_path__ + "static/media/Lightsaber Obi-Wan ANH - Img - Wip 8_06.e157c84c.jpg";